import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GenComTranslatePipe } from 'src/app/shared/pipes/gen-com-translate.pipe';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  message = '';
  messageChanged = new Subject<string>();

  constructor(private pipe: GenComTranslatePipe) { }

  getMessage() {
    return this.message;
  }

  setMessage(message: string) {
    this.message = this.pipe.transform(message);
    this.messageChanged.next(this.message);
  }
}
